import { Component, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../services/user.service';
import { ProjectsService } from '../../../services/projects.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrl: './create-user.component.scss'
})
export class CreateUserComponent {
  projects: any = [];
  user: {
    FirstName: string,
    LastName: string,
    Email: string,
    IsActive: boolean
    ExternalId: string | null,
    VerifyExternalId: boolean,
    IsAdmin: boolean,
    Project: any
  } = { FirstName: '', LastName: '', Email: '', IsActive: true, ExternalId: null, VerifyExternalId: false, IsAdmin: false, Project: null };

  constructor(
    @Optional() private readonly dialogRef: MatDialogRef<CreateUserComponent>,
    private readonly projectsService: ProjectsService,
    private readonly adminUserService: UserService
  ){
    this.projectsService.getProjectRoles().subscribe(_ => {
      this.projects = _;
    });
  }

  save() {
    var checkedRoles = document.querySelectorAll("input[type='checkbox'].role-checkbox:checked");
    var roles: string[] = [];
    checkedRoles.forEach((checkedRole: Element) => {
      roles.push((checkedRole as HTMLInputElement).value);
    });
    var data = {
      firstName: this.user.FirstName,
      lastName: this.user.LastName,
      email: this.user.Email,
      isActive: this.user.IsActive,
      externalId: this.user.ExternalId,
      verifyExternalId: this.user.VerifyExternalId,
      isAdmin: this.user.IsAdmin,
      projectId: this.user.Project?.projectId,
      roles: roles
    };
    this.adminUserService.createUser(data).subscribe(_ => {
      if (this.dialogRef) { this.dialogRef.close('save'); }
    });
  }
  close() {
    if (this.dialogRef) { this.dialogRef.close('cancel'); }
  }
}
